export default class BaseConnector {
  constructor(
    topX,
    topY,
    bottomX,
    bottomY,
    curveSize = 40,
  ) {
    this.topX = topX;
    this.topY = topY;
    this.bottomX = bottomX;
    this.bottomY = bottomY;
    this.curveSize = curveSize;
  }
}
